import { useState } from "react";
import { KeyRound, Loader2, Radio } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg, setToken } from "@/lib/api";

export default function LoginGate({ onDone }) {
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/dashboard/login", { secret });
      setToken(data.token);
      onDone();
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen grid-bg flex items-center px-6 sm:px-16">
      <form onSubmit={submit} className="rise w-full max-w-md space-y-8" data-testid="login-gate-form">
        <div className="space-y-3">
          <div className="flex items-center gap-2 text-cyan-400 text-xs font-mono uppercase tracking-[0.25em]">
            <Radio className="h-4 w-4" /> Internal service
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-100">
            Kite<span className="text-cyan-400">//</span>Bridge
          </h1>
          <p className="text-sm text-slate-400 max-w-sm">
            Live market-data bridge operator console. Enter the admin password or the master API key to continue.
          </p>
        </div>
        <div className="space-y-3">
          <div className="relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
            <Input
              data-testid="login-secret-input"
              type="password"
              autoFocus
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              placeholder="Admin password or master API key"
              className="pl-9 h-11 bg-slate-900/80 border-slate-800 font-mono text-slate-100"
            />
          </div>
          {err && <p data-testid="login-error" className="text-xs text-rose-400">{err}</p>}
          <Button data-testid="login-submit-button" disabled={busy || !secret} className="w-full h-11 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Open console"}
          </Button>
        </div>
        <p className="text-[11px] font-mono text-slate-600">Session lasts 12 hours. Data is for internal use only.</p>
      </form>
    </div>
  );
}
